"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCosmosTxData = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const types_1 = require("@shapeshiftoss/types");
const api_1 = require("../../../../api");
const getInboundAddressDataForChain_1 = require("../getInboundAddressDataForChain");
const getLimit_1 = require("../getLimit/getLimit");
const makeSwapMemo_1 = require("../makeSwapMemo/makeSwapMemo");
const getCosmosTxData = async (input) => {
    const { bip44Params, deps, destinationAddress, sellAmountCryptoBaseUnit, sellAsset, buyAsset, slippageTolerance, quote, wallet, sellAdapter, } = input;
    const fromThorAsset = sellAsset.chainId == types_1.KnownChainIds.ThorchainMainnet;
    const gaiaAddressData = await (0, getInboundAddressDataForChain_1.getInboundAddressDataForChain)(deps.daemonUrl, caip_1.cosmosAssetId);
    const vault = gaiaAddressData === null || gaiaAddressData === void 0 ? void 0 : gaiaAddressData.address;
    if (!vault && !fromThorAsset)
        throw new api_1.SwapError('[buildTrade]: no vault for chain', {
            code: api_1.SwapErrorTypes.BUILD_TRADE_FAILED,
            fn: 'buildTrade',
            details: { chainId: input.chainId },
        });
    const limit = await (0, getLimit_1.getLimit)({
        buyAssetId: buyAsset.assetId,
        sellAmountCryptoBaseUnit,
        sellAsset,
        slippageTolerance,
        deps,
        buyAssetTradeFeeUsd: quote.feeData.buyAssetTradeFeeUsd,
    });
    const memo = (0, makeSwapMemo_1.makeSwapMemo)({
        buyAssetId: buyAsset.assetId,
        destinationAddress,
        limit,
    });
    const builtTxResponse = await (async () => {
        switch (true) {
            case fromThorAsset:
                return await sellAdapter.buildDepositTransaction({
                    bip44Params,
                    value: sellAmountCryptoBaseUnit,
                    wallet,
                    memo,
                    chainSpecific: {
                        gas: quote.feeData.chainSpecific.estimatedGas,
                        fee: quote.feeData.networkFeeCryptoBaseUnit,
                    },
                });
            default:
                if (!vault)
                    throw new api_1.SwapError('[buildTrade]: no vault for chain', {
                        code: api_1.SwapErrorTypes.BUILD_TRADE_FAILED,
                        fn: 'buildTrade',
                        details: { chainId: input.chainId },
                    });
                return await sellAdapter.buildSendTransaction({
                    bip44Params,
                    value: sellAmountCryptoBaseUnit,
                    wallet,
                    to: vault,
                    memo,
                    chainSpecific: {
                        gas: quote.feeData.chainSpecific
                            .estimatedGas,
                        fee: quote.feeData.networkFeeCryptoBaseUnit,
                    },
                });
        }
    })();
    return builtTxResponse.txToSign;
};
exports.getCosmosTxData = getCosmosTxData;
